import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { handleAuthentication, showSnackBar } from "@containers/App/reducer"
import { parsePageInfoWidgets, parseWidgetData } from "./parser"
import { setRehashFlag } from "@containers/App/ABExperimentReducer/reducer.js"

const initialState = {
    isLoading: false,
    isFetched: false,
    error: null,
    widgets: {},
    pageInfoWidgets: {},
    defaultSelectedProcess: {},
}

export const dioOrderPreviewSlice = createSlice({
    name: "dioProcessData",
    initialState: initialState,
    reducers: {
        reset: () => initialState,
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchDioProcessData.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFetched = true
            state.error = false
            state.pageInfoWidgets = parsePageInfoWidgets(action.payload)
            const data = parseWidgetData(action.payload.widgets)
            state.widgets = data.widgets
            state.defaultSelectedProcess = data.selectedProcess
        }),
            builder.addCase(fetchDioProcessData.pending, (state) => {
                state.isLoading = true
                state.isFetched = false
                state.error = false
            }),
            builder.addCase(fetchDioProcessData.rejected, (state) => {
                state.isLoading = false
                state.error = true
                state.isFetched = false
            })
    },
})

export const fetchDioProcessData = createAsyncThunk(
    "dioOrderPreviewSlice/fetchDioPageProcessData",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const successCallback = _arg?.successCallback
        try {
            const res = await api.get(`api/v4/rx_order_preview_screen`)
            if (typeof successCallback === "function") {
                successCallback()
            }
            dispatch(setRehashFlag(res?.data?.rehash_data?.is_enabled))
            return Promise.resolve(res.data)
        } catch (err) {
            const errorCallback = _arg?.errorCallback
            if (typeof errorCallback === "function") {
                errorCallback()
            }
            const onServer = typeof window === "undefined"
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err)
        }
    }
)
export const createDioCart = createAsyncThunk(
    "dioOrderPreviewSlice/createDoneInOneCart",
    async (_arg, { extra, rejectWithValue, dispatch }) => {
        const { api } = extra
        const { payload, successCallback, errorCallback } = _arg
        try {
            const res = await api.post(`api/v4/create_cart`, payload)
            await Promise.resolve()
            if (typeof successCallback === "function") successCallback(res)
            return Promise.resolve(res?.data)
        } catch (err) {
            if (typeof successCallback === "function") errorCallback()
            if (err?.status_code !== 403 || err?.status_code !== 401) {
                showSnackBar(dispatch, err.error.message)
            }
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 403 || err.status_code === 401))
                dispatch(handleAuthentication())
            return rejectWithValue(err.error)
        }
    }
)

export const dioOrderPreviewReducer = dioOrderPreviewSlice.reducer
export const { reset } = dioOrderPreviewSlice.actions
